import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CostCenterTrans  {
    _originalTypeClassName = "zERP.BO.CostCenterTrans";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CostCenterTrans.translate = translateService;
}
this.CostCenter = new Domain.CostCenter();
this.CostCenterEmployee = [];
this.Id = null;
this.StartDate = null;
this.CostCenterFrom = null;
this.CostCenterTo = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StartDate:any;
CostCenterFrom:any;
CostCenterTo:any;
CostCenter:any;
UserAccount:any;
EmployeeContract:any;
CostCenterEmployee:any;
static setCostCenter = ($this, value) => {
var oldValue = $this.CostCenter;
$this.CostCenter = value;
if (value != null) {
}
}
static setUserAccount = ($this, value) => {
var oldValue = $this.UserAccount;
$this.UserAccount = value;
if (value != null) {
}
}
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setCostCenterEmployee = ($this, items) => {
                if (items == null) items = [];
                if ($this.CostCenterEmployee == null) $this.CostCenterEmployee = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CostCenterEmployee.length > 0) {
                    Domain.CostCenterTrans.removeCostCenterEmployee($this, $this.CostCenterEmployee[0]);
                }

                Domain.CostCenterTrans.addManyCostCenterEmployee($this, copyItems);
            }
static addManyCostCenterEmployee = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostCenterTrans.addCostCenterEmployee($this, items[i]);
                }
            }
static addCostCenterEmployee = ($this, item) => {
                if ($this.CostCenterEmployee == null) $this.CostCenterEmployee = [];
                if (item == null || $this.CostCenterEmployee.indexOf(item) > -1) return;
                $this.CostCenterEmployee.push(item);
}
static addRangeCostCenterEmployee = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostCenterTrans.addCostCenterEmployee($this, item));
            }
static removeCostCenterEmployee = ($this, item) => {
                if ($this == null || $this.CostCenterEmployee == null || $this.CostCenterEmployee.indexOf(item) === -1) return;
                var _index = $this.CostCenterEmployee.indexOf(item);
                $this.CostCenterEmployee.splice(_index, 1);
}
static clearCostCenterEmployee = ($this) => { $this.CostCenterEmployee = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}